import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { providers } from '../data/providers';
import { formatRtp, getProviderStats, getSlotsByProvider } from '../utils/slots';
import { useSeo } from '../hooks/useSeo';
import { YEAR, absoluteUrl, breadcrumbLd } from '../utils/seo';
export function Providers() {
  useSeo({
    title: `Slotproviders in Nieuw-Zeeland (${YEAR}) – Pragmatic Play, Play'n GO & meer | SlotGids`,
    description: `Overzicht van de ${providers.length} slotproviders achter de SlotGids Top 30 in Nieuw-Zeeland: Pragmatic Play, Play’n GO, NetEnt, Hacksaw Gaming en meer, met RTP en beste slots.`,
    path: '/providers',
    jsonLd: [breadcrumbLd([{
      name: 'Home',
      path: '/'
    }, {
      name: 'Providers',
      path: '/providers'
    }]), {
      '@type': 'ItemList',
      name: 'Slotproviders in Nieuw-Zeeland',
      itemListElement: providers.map((p, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        name: p.name,
        url: absoluteUrl(`/providers/${p.slug}`)
      }))
    }]
  });
  const ordered = [...providers].sort((a, b) => {
    const sa = getProviderStats(a.name);
    const sb = getProviderStats(b.name);
    return sb.count - sa.count || sa.bestRank - sb.bestRank;
  });
  return <main className="mx-auto max-w-7xl px-4 pt-10 sm:px-6" data-id="element-486" data-mp="tcrux2azcobi">
      <nav aria-label="Kruimelpad" className="flex items-center gap-1 text-sm text-muted" data-id="element-487" data-mp="fek0p25bw141">
        <Link to="/" className="hover:text-ink" data-id="element-488" data-mp="kefwie3vgm8i">Home</Link>
        <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-489" data-mp="kbto6c95q2p8" />
        <span className="text-ink" aria-current="page" data-id="element-490" data-mp="6fgevqes17lu">Providers</span>
      </nav>
      <h1 className="mt-6 font-serif text-4xl font-semibold tracking-tight sm:text-5xl" data-id="element-491" data-mp="agrztimph4np">Slotproviders in Nieuw-Zeeland</h1>
      <p className="mt-4 max-w-2xl text-lg text-muted" data-id="element-492" data-mp="20so4n3nwat0m">
        De {providers.length} studio’s achter onze Top 30, gesorteerd op het aantal slots in de ranglijst.
      </p>

      <ol className="mt-10 divide-y divide-line overflow-hidden rounded-2xl border border-line bg-surface" data-id="element-493" data-mp="3drre3enashaa">
        {ordered.map(p => {
        const stats = getProviderStats(p.name);
        const top = getSlotsByProvider(p.name)[0];
        return <li key={p.slug} data-id="element-494" data-mp="2zqx62x45wic5">
              <Link to={`/providers/${p.slug}`} className="grid grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-4 px-5 py-5 transition-colors duration-150 hover:bg-paper/60 sm:px-6 md:grid-cols-[auto_minmax(0,1.4fr)_minmax(0,1fr)_110px_90px_auto]" data-id="element-495" data-mp="2zrowltiwjpvk">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl font-serif font-semibold text-white" style={{
              backgroundColor: p.color
            }} aria-hidden="true" data-id="element-496" data-mp="3nnufuje8mdwp">
                  {p.name.replace(/[^A-Z]/g, '').slice(0, 2)}
                </span>
                <div className="min-w-0" data-id="element-497" data-mp="f6zmbujby5va">
                  <p className="font-semibold" data-id="element-498" data-mp="mkqpfxl9wwcm">{p.name}</p>
                  <p className="truncate text-sm text-muted" data-id="element-499" data-mp="mmbnhx6sqxf8">{p.signature}</p>
                </div>
                <p className="hidden truncate text-sm md:block" data-id="element-500" data-mp="rlehmml8nj8f">
                  <span className="text-muted" data-id="element-501" data-mp="whlnyghjqwqw">Hoogste: </span>#{top?.rank} {top?.name}
                </p>
                <p className="hidden text-sm tabular-nums md:block" data-id="element-502" data-mp="10krulp8kmpxw">
                  <span className="text-muted" data-id="element-503" data-mp="15jl3t5gtrus9">RTP </span>{formatRtp(stats.avgRtp)}
                </p>
                <p className="hidden font-serif text-xl font-semibold tabular-nums text-fern md:block" data-id="element-504" data-mp="1aheby41ouyv6">
                  {stats.count} <span className="font-sans text-xs font-normal text-muted" data-id="element-505" data-mp="1fa7gorx5q779">slots</span>
                </p>
                <ChevronRightIcon className="h-5 w-5 text-muted" aria-hidden="true" data-id="element-506" data-mp="1k7fzmuq4qf9k" />
              </Link>
            </li>;
      })}
      </ol>
    </main>;
}